'use strict';

var $ = require('jquery');

if( window.location.hash ) {
	setTimeout(() => {
		var anchor = document.querySelector(window.location.hash);
		anchor.scrollIntoView();
	}, 500);
}

if ( document.querySelector('.fixed-to-bottom') ) {
	var offset = document.querySelector('.fixed-to-bottom').clientHeight
	document.body.style.paddingBottom = offset + 'px'
}

// Function to check if element has been scrolled into view
function isIntoView(elem) {
    var documentViewTop = $(window).scrollTop();
    var documentViewBottom = documentViewTop + $(window).height();

    var elementTop = $(elem).offset().top;
    var elementBottom = elementTop + $(elem).height();

    return ((elementBottom <= documentViewBottom) && (elementTop >= documentViewTop));
}

// If items with contentFadeIn class exists
if ( 0 < $('.contentFadeIn').length ) {
	// Check each contentFadeIn item on scroll
	$( window ).scroll(function(){
		$('.contentFadeIn').each( function() {
			// If item doesn't already have fadeInUp class, check if it has been scrolled into view
			if ( ! $( this ).hasClass( 'animate__animated' ) ) {
				if ( isIntoView( this ) ){
					$( this ).addClass( 'animate__animated animate__fadeInUp animate__faster' );
				}
			}
		});
	})
}

$( document ).ready(function(){
	// Remove role=button from ac-triggers for accessibility
	$( '.ac-trigger.wp-block-button' ).removeAttr( 'role' );
	$( '.ac-trigger.wp-block-button a' ).attr( 'role', 'button' );
});

/**
 * Show/hide scroll to top button
 */
const updateScrollToTop = () => {

	var backToTop = document.getElementById('back-to-top')

	backToTop.addEventListener('click', (e) => {
		scrollTo(0,0)
	})

	if ( 1000 < window.pageYOffset ) {
		backToTop.classList.add('visible')
	} else {
		backToTop.classList.remove('visible')
	}

}
window.addEventListener('scroll', updateScrollToTop)

/**
 * Make sticky navs sticky at the top of the window.
 */
// Throttle utility, so we don't recalculate sticky statuses more often than needed.
const throttle = callback => {
	let wasCalled = false;
	let timer = false;
	return () => {
		wasCalled = true;
		if (!timer) {
			callback();
			wasCalled = false;
			timer = setTimeout(() => {
				if (wasCalled) {
					callback();
					wasCalled = false;
				}
				timer = false;
			}, 50);
		}
	};
}
// On first run, we'll need to add a placeholder div after each sticky.
let stickyPlaceholdersAdded = false;
const hasAdminBar = document.body.classList.contains('admin-bar');
const doStickies = throttle(() => {
	const stickies = document.querySelectorAll('.sticky');
	// Add placeholders, which will occupy the space of 'stuck' elements so that other elements aren't
	// moved around and the document height doesn't change.
	if (!stickyPlaceholdersAdded) {
		for (const sticky of stickies) {
			const placeholder = document.createElement('div');
			placeholder.classList.add('sticky-placeholder');
			sticky.after(placeholder);
		}
		stickyPlaceholdersAdded = true;
	}
	// There can be more than one sticky element on a page. Keep track of the combined height of all
	// sticky elements so that we can sticky-stack them below one another.
	// Start at a top distance of 32 if the WP admin bar is visible.
	let minTopDistance = (hasAdminBar ? 32 : 0);
	for (const sticky of stickies) {
		const isStuck = sticky.classList.contains('is-stuck');
		const placeholder = sticky.nextSibling;
		// For stuck elements, measure position/height of placeholder, not sticky element.
		const rect = (isStuck ? placeholder : sticky).getBoundingClientRect();
		if (rect.top < minTopDistance) {
			if (!isStuck) {
				// Set placeholder height to match sticky element.
				placeholder.style.height = window.getComputedStyle(sticky).height;
				// Stick it.
				sticky.classList.add('is-stuck');
				// Set a variable that the stylesheet will use as the 'top' value, instead of setting 'top'
				// directly, so that mobile/tablet can ignore sticky styles.
				sticky.style.setProperty('--sticky-top', minTopDistance + 'px');
			}
		} else if (isStuck) {
			sticky.classList.remove('is-stuck');
		}
		minTopDistance += Math.floor(rect.height);
	}
});
window.addEventListener('resize', doStickies);
window.addEventListener('scroll', doStickies);
doStickies();
